// src/pages/PaymentComplete.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Loader } from 'lucide-react';

const PaymentComplete = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const planId = searchParams.get('plan') || 'student';

  const planNames = {
    student: 'Student',
    standard: 'Standard',
    business: 'Business',
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {/* アイコン */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-amber-400/10 border border-amber-400/30 flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-amber-400" />
          </div>
        </div>

        {/* タイトル */}
        <div className="flex items-center gap-3 justify-center mb-2">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-amber-400/50" />
          <span className="text-xs text-amber-400 tracking-widest uppercase font-medium">Payment Complete</span>
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-amber-400/50" />
        </div>
        <h1 className="text-3xl font-bold mb-3">決済が完了しました</h1>
        <p className="text-white/60 mb-2">
          <span className="text-amber-400 font-semibold">{planNames[planId] || planId} プラン</span> へのアップグレードありがとうございます。
        </p>
        <p className="text-white/40 text-sm mb-8">
          プランは自動的に反映されます。反映まで少々お待ちください。
        </p>

        {/* カウントダウン */}
        <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-6">
          <div className="flex items-center justify-center gap-3 text-white/60 text-sm">
            <Loader className="w-4 h-4 animate-spin text-amber-400" />
            <span>{countdown}秒後にダッシュボードへ移動します...</span>
          </div>
          <div className="mt-3 w-full bg-white/10 rounded-full h-1">
            <div
              className="bg-amber-400 h-1 rounded-full transition-all duration-1000"
              style={{ width: `${((5 - countdown) / 5) * 100}%` }}
            />
          </div>
        </div>

        <button
          onClick={() => navigate('/dashboard')}
          className="w-full py-3 bg-amber-400 text-black font-semibold rounded-xl hover:bg-amber-300 transition-colors"
        >
          今すぐダッシュボードへ
        </button>
      </div>
    </div>
  );
};

export default PaymentComplete;
